module.exports = __webpack_public_path__ + "media/svg-new/icon-max1-branco-5b6507ae.svg";